import { useLazyGetCompaniesQuery } from '../../../../../redux/api/companiesApi';
import { Option } from 'components/formComponents/Base/Dropdown';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import Dropdown from 'components/formComponents/Base/Dropdown';
import TextBlock from 'components/formComponents/Base/TextBlock';
import { setPartyRegardingApplication } from '../../../../../redux/reducer/partyApplicationSlice';
import { useAppDispatch } from '../../../../../hooks';
import { PartyRegardingApplicationSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';

type Props = {
  texts?: PartyRegardingApplicationSectionTexts;
};

const CompanyBlock = ({ texts }: Props) => {
  const dispatch = useAppDispatch();
  const { watch, setValue } = useFormContext();
  const [triggerGetCompanies] = useLazyGetCompaniesQuery();
  const organizationNumber = watch('partyRegardingApplication');

  const onSelectCompany = (option: Option | null) => {
    if (!option) {
      setValue('partyRegardingApplication', undefined);
      return;
    }
    setValue('partyRegardingApplication', option.value);
    dispatch(setPartyRegardingApplication(option.value));
  };

  const loadCompanyOptions = useCallback(
    async (searchInput: string): Promise<Option[]> => {
      if (!searchInput || searchInput.length < 2) {
        return [];
      }

      try {
        const result = await triggerGetCompanies(searchInput).unwrap();

        return result.map((company) => ({
          value: company.OrgNr,
          label: company.Företagsnamn,
          subLabel: company.OrgNr,
        }));
      } catch (error) {
        console.error('Error loading companies:', error);
        return [];
      }
    },
    [triggerGetCompanies]
  );
  return (
    <>
      <Dropdown
        name="partyRegardingApplication"
        label={
          texts?.partyRegardingApplication?.label ??
          'Företagets organisationsnummer'
        }
        placeholder={
          texts?.partyRegardingApplication?.placeholder ??
          'Skriv namn eller organisationsnummer'
        }
        debounceMs={500}
        minSearchLength={2}
        onChange={onSelectCompany}
        loadOptions={loadCompanyOptions}
      />
      {!organizationNumber && (
        <TextBlock
          type="info"
          text={
            texts?.partyRegardingApplicationInfo ??
            'Om du inte hittar rätt företag kan du söka på allabolag.se'
          }
        />
      )}
    </>
  );
};

export default CompanyBlock;
